<div class="host-vrbo-link">
  <div class="step-1" *ngIf="step === 1">
    <p class="title">
      <!-- 直连Vrbo -->
      {{ "channel.vrbo.link.step1.title" | translate }}
    </p>
    <p class="desc">
      {{ "channel.vrbo.link.step1.desc" | translate }}
      <!-- 请输入您的Vrbo账号和密码以直连 -->
    </p>

    <div class="form" [formGroup]="form">
      <div class="form-item">
        <input nz-input type="text" [placeholder]="'channel.vrbo.link.step1.placeholder_1' | translate" formControlName="username"/>
      </div>
      <div class="form-item">
        <input nz-input type="password" [placeholder]="'channel.vrbo.link.step1.placeholder_2' | translate" formControlName="password"/>
      </div>
    </div>

    <div class="btn">
      <button nz-button nzType="primary" nzBlock [nzLoading]="loading" (click)="onClickCreate()">
        {{ "channel.vrbo.link.step.next_btn" | translate }}
        <!-- 下一步 -->
      </button>
    </div>
  </div>

  <div class="step-2" *ngIf="step === 2">
    <p class="title">
      {{ "channel.vrbo.link.step2.title" | translate }}
      <!-- 二次验证 -->
    </p>
    <p class="desc">
      {{ "channel.vrbo.link.step2.desc" | translate }}
      <!-- 请选择验证的方式 -->
    </p>
    <div class="form">
      <div class="form-item">
        <button nz-button nzBlock (click)="onClickVerifyType('sms')">
          {{ "channel.vrbo.link.step2.verify_btn_1" | translate }}
          <!-- 给我发送短信 -->
        </button>
      </div>
      <div class="form-item">
        <button nz-button nzBlock (click)="onClickVerifyType('call')">
          {{ "channel.vrbo.link.step2.verify_btn_2" | translate }}
          <!-- 给我打电话 -->
        </button>
      </div>
    </div>
  </div>

  <div class="step-3" *ngIf="step === 3">
    <div class="title">
      {{ "channel.vrbo.link.step3.title" | translate }}
      <!-- 输入验证码 -->
    </div>
    <div class="form" [formGroup]="verifyForm">
      <div class="form-item">
        <input nz-input type="text" [placeholder]="'channel.vrbo.link.step3.placeholder' | translate" formControlName="code">
      </div>
    </div>
    <div class="btn">
      <button nz-button nzType="primary" nzBlock [nzLoading]="loading" (click)="onClickSubmitCode()">
        {{ "channel.vrbo.link.step.next_btn" | translate }}
        <!-- 下一步 -->
      </button>
    </div>
  </div>
</div>
